import moment from "../../moment";

// APIで取得できる選択可能日付の開始日が今日以前になる場合があり、その場合は今日を選択可能範囲の開始日とする必要がある
// 戻り値のフォーマットは "YYYY-MM-DD"
export const getBoardingStartDate = (boardingStartDate) => {
  const now = new Date();
  // 3:00が運行日の切り替わり基準なので調整
  now.setHours(now.getHours() - 3);

  // 時刻によって正常な比較ができない場合があるので、形式を揃える
  const nowYMDString = `${now.getFullYear()}-${zeroFill(now.getMonth() + 1)}-${zeroFill(now.getDate())}`;

  if (moment(new Date(boardingStartDate)).isBefore(moment(new Date(nowYMDString)))) {
    return nowYMDString;
  } else {
    return boardingStartDate;
  }
}

// 常に"YYYY-MM-DD"にするため、月日をゼロ埋めする処理
const zeroFill = (num) => {
  return num.toString().padStart(2, "0");
}